<div class="margin-top-10" *ngIf="!(VideoUserTags.usersTag$ | async).length">
	{{ 'InThisVideo_NoTagsPresent' | translate }}
</div>

<vb-ui-toggle-content-display [minItems]="4" [totalItems]="(VideoUserTags.usersTag$ | async)?.length">
	<div *ngFor="let tag of VideoUserTags.usersTag$ | async" #vbUiToggleItem>
		<in-this-video-entry-angular [activeUserTagId]="(VideoUserTags.activeUserTag$ | async)?.userId" [tag]="tag" (onToggle)="onEntryToggle($event.tag)">
		</in-this-video-entry-angular>
	</div>
</vb-ui-toggle-content-display>
